<rt-date-range-picker
  [disabled]="disabled()"
  [value]="dateRangeValue"
  [possibleDateRanges]="possibleDateRanges()"
  [dropdownPosition]="dropdownPosition()"
  [customRangeDirection]="datePickerDirection()"
  [label]="label()"
  [placeholder]="placeholder()"
  [addClearOption]="addClearOption()"
  [blackout]="blackout()"
  (valueChange)="handleDateRangeChange($event)"
/>
